import EditLinks from "./EditLinks";
import ViewLinks from "./ViewLinks";
import { useState } from "react";
import { saveSubscriptionLinks } from "../../../services/saveSubscriptionLinks";
import { validateJSONString } from "../../../helpers/validateJSONString";
import toast from "react-hot-toast";
import { usePermissions } from "../../../context/PermissionsContext";

const ClientServiceLinks = ({ clientService, setClientService }) => {
  const { can, permissionsLoading } = usePermissions();
  const canReadServices = !permissionsLoading && can("client_services.read");
  const canWriteServices = !permissionsLoading && can("client_services.write");
  const [editLinks, setEditLinks] = useState(false);

  async function saveLinks(newLinks) {
    if (!canWriteServices) return;

    const response = await saveSubscriptionLinks(clientService.id, newLinks);
    toast.success(response.data.message);
    console.log("links", newLinks);
    setClientService({ ...clientService, links: newLinks });
  }

  if (!canReadServices) return null;

  return (
    <div className="w-full">
      {editLinks ? (
        <EditLinks
          links={validateJSONString(clientService.links)}
          saveLinks={saveLinks}
          setEditLinks={setEditLinks}
        />
      ) : (
        <ViewLinks
          label="Permanent Links"
          links={validateJSONString(clientService.links)}
          setEditLinks={setEditLinks}
          canEdit={canWriteServices}
        />
      )}
    </div>
  );
};

export default ClientServiceLinks;
